import styled from "styled-components";
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background: rgba(0, 0, 0, 0.75);
`;
export const Container = styled.div`
  border-radius: 15px;
  position: fixed;
  background-color: #ffe6e6;
  top: 40vh;
  left: 20%;
  width: 60%;
  z-index: 100;
  overflow: hidden;
  @media (min-width: 768px) {
    left: calc(50% - 20rem);
    width: 40rem;
  }
`;
export const Message = styled.div`
  padding: 1rem;
`;
export const Header = styled.header`
  background: crimson;
  padding: 1rem;
  color: white;
`;
export const Footer = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
`;
